module.exports = __webpack_public_path__ + "img/TABLE_INSERT.a1325952.png";